import frozen_durian_400 from "../images/durianfruitfrozen/mkfrozen_square.webp";
import frozen_durian_500 from "../images/durianfruitfrozen/mkfrozen2.webp";
import frozen_durian_24_400 from "../images/durianfruitfrozen/mkfrozen2_alt.webp";
import duriand24 from "../images/durianfruitfrozen/duriand24.webp";
import d24_durian_puree from "../images/durianPuree/d24Puree.webp";
import d197_durian_puree from "../images/durianPuree/mkpuree3.webp";
import d197_durian from "../images/durianfruit/IMG_8586.webp";
import black_durian from "../images/durianfruit/black3sq.webp";
import durian_mochi_1 from "../images/durianfruitfrozen/durian_mochi_1.webp";
import durian_mochi_2 from "../images/durianfruitfrozen/durian_mochi_2.webp";
import durian_mochi_3 from "../images/durianfruitfrozen/durian_mochi_3.webp";
import durian_mochi_4 from "../images/durianfruitfrozen/durian_mochi_4.webp";
import durian_mochi_5 from "../images/durianfruitfrozen/durian_mochi_5.webp";

const product_info = [
  {
    title: "貓山王鮮果",
    category: "fresh",
    summary: "馬來西亞 D197 貓山王，每週空運到港，嚴選整箱批發。",
    specs: [
      { label: "產地", value: "馬來西亞" },
      { label: "品種", value: "D197 貓山王" },
      { label: "規格", value: "整箱 10kg / 22磅（4–6 顆）" },
      { label: "供應", value: "每週空運到港" },
    ],
    pricing: [],
    pricingNote: "（批發價另議）",
    story:
      "與馬來西亞果園直接合作，每顆貓山王經挑選後空運到港。適合即食、宴客及餐飲用途，旺季供應穩定。",
    image: [d197_durian],
    imageCaption: "D197 貓山王鮮果",
    url_link: "mskfruit",
    meta_description:
      "馬來西亞頂級貓山王鮮果｜D197貓山王香港直送｜每週新鮮空運到港",
  },
  {
    title: "黑刺榴槤鮮果",
    category: "fresh",
    summary: "馬來西亞 D200 黑刺榴槤，果肉細膩香甜，整箱批發直送香港。",
    specs: [
      { label: "產地", value: "馬來西亞" },
      { label: "品種", value: "D200 黑刺" },
      { label: "規格", value: "整箱 10kg / 22磅（4–6 顆）" },
      { label: "供應", value: "每週空運到港" },
    ],
    pricing: [],
    pricingNote: "（批發價另議）",
    story:
      "黑刺榴槤以濃郁奶香與細緻口感著稱，產量稀少。適合高端零售及餐飲菜單用料。",
    image: [black_durian],
    imageCaption: "D200 黑刺榴槤鮮果",
    url_link: "d200fruit",
    meta_description:
      "黑刺榴槤鮮果D200｜馬來西亞黑刺｜香港直送｜頂級榴槤",
  },
  {
    title: "D197貓山王•急凍果肉 400g",
    category: "frozen",
    summary: "嚴選 D197 果肉急凍保鮮，400g 家庭及小型餐飲適用。",
    specs: [
      { label: "品種", value: "D197 貓山王" },
      { label: "淨重", value: "400g / 盒" },
      { label: "保存", value: "急凍 -18°C" },
      { label: "用途", value: "即食、甜品、雪糕餡料" },
    ],
    pricing: [],
    pricingNote: "（批發價另議）",
    story:
      "果肉經急凍鎖鮮，解凍後可即食或作烘焙、甜品餡料。全年穩定供應，無需等待鮮果季節。",
    image: [frozen_durian_400],
    imageCaption: "D197 貓山王急凍果肉 400g",
    url_link: "d197fruit400",
    meta_description:
      "D197貓山王急凍果肉400g｜馬來西亞頂級榴槤｜隨時享用貓山王｜急凍保鮮｜香港批發零售",
  },
  {
    title: "D24蘇丹王 •急凍果肉 400g",
    category: "frozen",
    summary: "D24 蘇丹王急凍果肉，性價比高，適合餐飲及家庭食用。",
    specs: [
      { label: "品種", value: "D24 蘇丹王" },
      { label: "淨重", value: "400g / 盒" },
      { label: "保存", value: "急凍 -18°C" },
      { label: "用途", value: "即食、甜品、雪糕餡料" },
    ],
    pricing: [],
    pricingNote: "（批發價另議）",
    story:
      "蘇丹王果肉香甜穩定，急凍處理方便儲存。常用於甜品店及餐廳榴槤菜式。",
    image: [duriand24, frozen_durian_24_400],
    imageCaption: "D24 蘇丹王急凍果肉 400g",
    url_link: "d24fruit400",
    meta_description:
      "D24蘇丹王急凍果肉400g｜馬來西亞蘇丹王榴槤｜急凍保鮮｜香港批發零售｜貓山王朝",
  },
  {
    title: "D197貓山王•急凍果肉 500g",
    category: "frozen",
    sold_out: true,
    summary: "D197 貓山王 500g 大容量裝，適合分享及餐飲備貨。",
    specs: [
      { label: "品種", value: "D197 貓山王" },
      { label: "淨重", value: "500g / 盒" },
      { label: "保存", value: "急凍 -18°C" },
      { label: "用途", value: "即食、甜品、雪糕餡料" },
    ],
    pricing: [],
    pricingNote: "（批發價另議）",
    story:
      "500g 大容量裝滿足更高用量需求，同樣採用急凍保鮮技術，方便餐飲及家庭大量備貨。",
    image: [frozen_durian_500],
    imageCaption: "D197 貓山王急凍果肉 500g",
    url_link: "d197fruit500",
    meta_description:
      "D197貓山王急凍果肉500g｜馬來西亞頂級榴槤大容量｜急凍保鮮｜香港批發零售",
  },
  {
    title: "D24蘇丹王泥",
    category: "frozen",
    summary: "D24 榴槤泥 2kg 大包裝，餐飲烘焙用量大之選。",
    specs: [
      { label: "品種", value: "D24 蘇丹王" },
      { label: "淨重", value: "2kg / 包" },
      { label: "質地", value: "綿密果泥" },
      { label: "用途", value: "烘焙、雪糕、甜品餡料" },
    ],
    pricing: [],
    pricingNote: "（批發價另議）",
    story:
      "成熟 D24 果肉打製成泥，口感細滑穩定。適合甜品生產及餐飲中央廚房。",
    image: [d24_durian_puree],
    imageCaption: "D24 蘇丹王榴槤泥 2kg",
    url_link: "d24fruitpuree",
    meta_description:
      "D24蘇丹王泥2kg｜馬來西亞榴槤泥｜批發零售香港",
  },
  {
    title: "D197貓山王泥",
    category: "frozen",
    summary: "頂級 D197 貓山王果泥，餐飲及精品甜品首選。",
    specs: [
      { label: "品種", value: "D197 貓山王" },
      { label: "淨重", value: "2kg / 包" },
      { label: "質地", value: "濃郁綿密果泥" },
      { label: "用途", value: "烘焙、雪糕、精品甜品" },
    ],
    pricing: [],
    pricingNote: "（批發價另議）",
    story:
      "以優質貓山王果肉製成，香氣濃郁、口感細膩。適合高端甜品菜單及榴槤主題烘焙。",
    image: [d197_durian_puree],
    imageCaption: "D197 貓山王榴槤泥 2kg",
    url_link: "d197fruitpuree",
    meta_description:
      "D197貓山王泥2kg｜馬來西亞頂級榴槤泥｜批發零售香港",
  },
  {
    title: "榴槤糯米糍",
    category: "frozen",
    summary: "急凍榴槤糯米糍，備有貓山王及黑刺兩款口味，每盒 4 粒，解凍即食。",
    specs: [
      { label: "品種", value: "貓山王、黑刺" },
      { label: "規格", value: "每盒 4 粒" },
      { label: "保存", value: "急凍 -18°C" },
      { label: "用途", value: "即食、甜品等等" },
    ],
    pricing: [],
    pricingNote: "（批發價另議）",
    story:
      "嚴選貓山王及黑刺榴槤果肉製成糯米糍，急凍鎖鮮方便儲存。兩款口味各有特色，解凍後即可享用，適合甜品店、零售及宴客分享。",
    image: [durian_mochi_1, durian_mochi_2, durian_mochi_3, durian_mochi_4, durian_mochi_5],
    imageCaption: "榴槤糯米糍（貓山王 / 黑刺）",
    url_link: "durianmochi",
    meta_description:
      "榴槤糯米糍｜貓山王、黑刺兩款｜每盒 4 粒｜急凍保鮮｜即食甜品｜香港批發零售｜貓山王朝",
  },
];

export function filterProductsByCategory(products, categoryId) {
  if (!categoryId || categoryId === "all") return products;
  const id = categoryId === "puree" ? "frozen" : categoryId;
  return products.filter((p) => p.category === id);
}

export default product_info;
